import { styled, View } from "@tamagui/core";
import { Icon } from "../Icon/Icon.mjs";
import { jsx } from "react/jsx-runtime";
const BaseSquircle = styled(View, {
    alignItems: "center",
    borderRadius: "$squircle.radius",
    defaultVariants: {
      size: "$squircle.size.regular"
    },
    justifyContent: "center",
    name: "SunshineBaseSquircle",
    overflow: "hidden",
    variants: {
      size: {
        "...size": value => ({
          height: value,
          width: value
        })
      }
    }
  }),
  Squircle = ({
    backgroundColor,
    icon,
    ...props
  }) => /* @__PURE__ */jsx(BaseSquircle, {
    backgroundColor,
    ...props,
    children: icon ? /* @__PURE__ */jsx(Icon, {
      icon
    }) : null
  });
export { Squircle };
//# sourceMappingURL=Squircle.mjs.map
